import { createAction } from 'redux-actions';

export const stepDialogOpen = createAction('STEPDIALOG_OPEN');
export const stepDialogClose = createAction('STEPDIALOG_CLOSE');
export const stepDialogStatePrepare = createAction('STEPDIALOGSTATE_PREPARE');
export const stepDialogUpdate = createAction('STEPDIALOG_UPDATE');
export const stepDialogUpdated = createAction('STEPDIALOG_UPDATED');
export const stepDialogSave = createAction('STEPDIALOG_SAVE');
export const stepChoicesUpdate = createAction('STEPCHOICES_UPDATE');
export const nextStepsUpdate = createAction('NEXTSTEPS_UPDATE');
